import React, { Component } from "react";
import closeButton from "./assets/Close.svg";
import successIcon from "./assets/Success2.svg";
import errorIcon from "./assets/Error.svg";
import infoIcon from "./assets/icons-info.svg";
import { ToastContainer, toast } from "react-toastify";
import toDate from "date-fns/toDate/index.js";
import "react-perfect-scrollbar/dist/css/styles.css";

export let successToastStyle = {
  className: "toast-success",
  closeButton: <img className="close-icon" src={closeButton} />,
  progressStyle: {
    backgroundColor: "rgba(105, 232, 137, 0.4)",
    height: "68px",
    borderRadius: "8px, 0px, 0px, 8px"
  },
  icon: <img className="icon-st" src={successIcon} />
};

export let errorToastStyle = {
  className: "toast-error",
  closeButton: <img className="close-icon" src={closeButton} />,
  progressStyle: {
    backgroundColor: "rgba(232, 105, 105, 0.4)",
    height: "68px",
    borderRadius: "8px 0px 0px 8px"
  },
  icon: <img className="icon-st" src={errorIcon} />
};

export let infoToastStyle = {
  className: "toast-info",
  closeButton: <img className="close-icon" src={closeButton} />,
  progressStyle: {
    backgroundColor: "rgba(33,150,243, 0.4)",
    height: "68px",
    borderRadius: "8px 0px 0px 8px"
  },
  icon: <img className="icon-st" src={infoIcon} />
};
